export const ROUTES = {
	BASE: ``,
	PET_INFORMATION: `pet-information`,
	SELECT_A_POLICY: `select-a-policy`,
	CONTACT_INFORMATION: `contact-information`,
	CONGRATULATIONS: `congratulations`,
	ERROR: `error`,
	PREQUOTE: `prequote`,
	RETRIEVE: `retrieve`,
	QUOTE_ENGINE: `QuoteEngine`,
	RETRIEVE_WITH_TYPE: `retrieve/:retrieveType`,
};
